import { render, staticRenderFns } from "./PbDashboardToQueueSender.vue?vue&type=template&id=56798833&"
import script from "./PbDashboardToQueueSender.vue?vue&type=script&lang=js&"
export * from "./PbDashboardToQueueSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports